import angular from 'angular'

export default angular.module('app', ['ui.router', 'interface', 'ngStorage', 'hc.marked'])



// WEBPACK FOOTER //
// ./src/app/module.js